var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7025 3.05933C6.48865 3.05933 2.26196 7.28601 2.26196 12.4999C2.26196 17.7138 6.48865 21.9404 11.7025 21.9404C16.9164 21.9404 21.1431 17.7138 21.1431 12.4999C21.1431 7.28601 16.9164 3.05933 11.7025 3.05933ZM0.164062 12.4999C0.164062 6.12737 5.33001 0.961426 11.7025 0.961426C18.075 0.961426 23.241 6.12737 23.241 12.4999C23.241 18.8724 18.075 24.0383 11.7025 24.0383C5.33001 24.0383 0.164062 18.8724 0.164062 12.4999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21801 8.17908L16.0235 15.9845L15.1872 16.8208L7.38171 9.01538L8.21801 8.17908Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38171 15.9844L15.1872 8.17892L16.0235 9.01522L8.21801 16.8207L7.38171 15.9844Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/error_outline.4d782d67aaa515de7bf91bc14ccd2a47.svg";
export { ForwardRef as ReactComponent };